import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import _ from 'lodash';
import { teacherFetchStudentMissions, } from '../../services2/studentMissions.service';
import MissionResult from '../admin/components/MissionResult.js';

function Component(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    const [mission, setmission] = useState(null)
    const [isLoading, setisLoading] = useState(false)

    const fetchMission = async () => {
        let result = await teacherFetchStudentMissions(props.token.token, { _id: id });
        if (result.result) {
            setmission(result.result?.[0] || null)
        } else {
            alert('Fetch data error')
        }
    }

    const refresh = async () => {
        if (isLoading) return
        setisLoading(true)
        await fetchMission()
        setisLoading(false)
    }

    useEffect(() => {
        refresh()
    }, [id])

    return (
        <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex text-[16px] text-[black]' style={{ overflowY: "auto" }}>
            <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap pl-[16px] pt-[16px]'>
                <div className='text-[#1D1D41] text-[24px] font-[400] cursor-pointer' onClick={() => { navigate(`/platform2/results/${mission?.missionId}`) }}>{`<`} 返回</div>
                <div className='cursor-pointer underline text-[#1F4CC8] text-[14px] font-[700] mr-[24px]' onClick={() => { navigate(`/platform2/studentreports/${id}`) }}>
                    學生閱讀成績單
                </div>
            </div>
            <MissionResult refresh={refresh} mission={mission} setmission={setmission}/>
        </div>
    )

}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
